import styled from "styled-components";

export const ButtonEditorContainer = styled.div`
  display: grid;
  place-content: center;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  margin-bottom: 116px;
`;

export const ButtonEditorSkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ gap = "24px" }) => gap};
`;

export const ButtonEditorSkeleton = styled.div`
  background-color: ${({ theme }) => theme.border.black15};
  border-radius: ${({ borderRadius = "8px" }) => borderRadius};
  width: ${({ width = "600px" }) => width};
  height: ${({ height = "32px" }) => height};
`;
